<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>外管工作台</Breadcrumb-item>
        <Breadcrumb-item>合同到期提醒</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="rule-bar">
      <span class="rule-dot"></span>
      规则：合同到期前 <b>{{ rules.contractAlertDays }}</b> 天触发续签提醒；到期日次日起进入<b>超期</b>状态并按天累计，直至登记新合同。未登记合同的老师只在「全部」里显示。
      <a href="javascript:;" @click="$router.push('/hrWorkbench/settings')">调整规则</a>
    </div>
    <div class="filter-bar">
      <span class="toolbar-label">外教运营</span>
      <adviser-select v-model="adviserId" @on-change="onAdviserChange"></adviser-select>
      <Button-group class="seg">
        <Button v-for="item in levelTabs" :key="item.value"
                :type="level === item.value ? 'primary' : 'ghost'"
                @click="changeLevel(item.value)">
          {{ item.label }} {{ counts[item.value] || 0 }}
        </Button>
      </Button-group>
      <span class="toolbar-total">共 {{ dataList.length }} 人</span>
      <Button class="export-btn" @click="exportCsv">导出</Button>
    </div>
    <div class="list-table">
      <Table :columns="columns" :data="dataList" :loading="searchLoading" stripe
             :row-class-name="rowClassName" no-data-text="当前筛选下无记录"></Table>
    </div>
    <contract-renew-modal :value="showRenew" :row="currentRow"
                          @on-close="showRenew = false" @on-success="search"></contract-renew-modal>
    <tch-info-modal :value="showTchInfoModal" :tchId="tchInfoId" @on-close="showTchInfoModal = false"></tch-info-modal>
  </div>
</template>
<script>
import AdviserSelect from './AdviserSelect.vue'
import ContractRenewModal from './modal/ContractRenewModal.vue'
import TchInfoModal from '../teacher/modal/TchInfoModal.vue'
import { API_PREFIX, CONTRACT_LEVEL, codeText, codeColor, tchLabel, adviserParam, downloadCsv, resolveAdviserId, writeStoredAdviserId} from './constants'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
const LEVEL_KEYS = ['open', 'expired', 'expiring', 'normal', 'all']
const SUGGEST = {
  expired: '立即推进签署',
  expiring: '发起续签沟通，确认续签意向',
  normal: '正常履约',
  missing: '未登记合同'
}
export default {
  name: 'HrWorkbenchContract',
  components: { AdviserSelect, ContractRenewModal, TchInfoModal },
  data () {
    let q = this.$route.query || {}
    return {
      adviserId: resolveAdviserId(q),
      level: LEVEL_KEYS.indexOf(q.level) >= 0 ? q.level : 'open',
      counts: {},
      rules: {},
      dataList: [],
      searchLoading: false,
      rankScoreSeq: 0,
      showRenew: false,
      currentRow: null,
      showTchInfoModal: false,
      tchInfoId: null,
      columns: []
    }
  },
  computed: {
    levelTabs () {
      return [
        { value: 'open', label: '待处理' },
        { value: 'expired', label: '已超期' },
        { value: 'expiring', label: (this.rules.contractAlertDays || '—') + ' 天内到期' },
        { value: 'normal', label: '有效期内' },
        { value: 'all', label: '全部' }
      ]
    }
  },
  created () {
    writeStoredAdviserId(this.adviserId)
    this.$root.$emit('hr-badges-refresh')

    let self = this
    this.columns = [
      {
        title: '外教',
        key: 'tchName',
        width: 200,
        render: (h, params) => self.renderTch(h, params.row)
      },
      {
        title: '外教运营',
        key: 'studyAdviserName',
        width: 140,
        render: (h, params) => h('span', params.row.studyAdviserName || '未分配')
      },
      {
        title: '合同期',
        key: 'crtEndDate',
        width: 200,
        render: (h, params) => {
          let row = params.row
          if (!row.crtEndDate) {
            return h('span', { class: 'muted' }, '未登记合同')
          }
          return h('span', (row.crtBeginDate || '—') + ' ~ ' + row.crtEndDate)
        }
      },
      {
        title: '剩余/超期(天)',
        key: 'daysLeft',
        width: 110,
        align: 'center',
        render: (h, params) => {
          let row = params.row
          if (row.daysLeft == null || row.level === 'missing') {
            return h('span', { class: 'muted' }, '—')
          }
          return h('b', { class: row.daysLeft < 0 ? 'text-danger' : '' }, row.daysLeft)
        }
      },
      {
        title: '状态',
        key: 'level',
        width: 230,
        render: (h, params) => {
          let row = params.row
          let text = codeText(CONTRACT_LEVEL, row.level) || '—'
          if (row.level === 'expired' && row.daysLeft != null) {
            text = '超期 ' + Math.abs(row.daysLeft) + ' 天'
          } else if ((row.level === 'expiring' || row.level === 'normal') && row.daysLeft != null) {
            text = '剩 ' + row.daysLeft + ' 天'
          }
          let tags = [h('Tag', { props: { color: codeColor(CONTRACT_LEVEL, row.level) } }, text)]
          if (row.renewCount) {
            tags.push(h('Tag', '已续签 ' + row.renewCount + ' 次'))
          }
          if (row.schedulePaused) {
            tags.push(h('Tag', { props: { color: 'yellow' } }, '已暂停排课'))
          }
          return h('div', tags)
        }
      },
      {
        title: '最近续签备注',
        key: 'lastRenewNote',
        width: 180,
        render: (h, params) => h('span', { class: params.row.lastRenewNote ? '' : 'muted' }, params.row.lastRenewNote || '—')
      },
      {
        title: '建议动作',
        key: 'suggest',
        width: 180,
        render: (h, params) => h('span', { class: 'muted' }, SUGGEST[params.row.level] || '')
      },
      {
        title: '操作',
        key: 'action',
        width: 250,
        align: 'center',
        render: (h, params) => {
          let row = params.row
          return h('div', [
            h('Button', {
              props: { size: 'small' },
              on: { click: () => self.openTchInfo(row.tchId) }
            }, '档案'),
            h('Button', {
              props: { type: 'primary', size: 'small' },
              style: { marginLeft: '6px' },
              on: { click: () => self.openRenew(row) }
            }, '登记续签'),
            h('Button', {
              props: { size: 'small' },
              style: { marginLeft: '6px' },
              on: { click: () => self.confirmSchedule(row) }
            }, row.schedulePaused ? '恢复排课' : '暂停排课')
          ])
        }
      }
    ]
  },
  mounted () {
    this.search()
  },
  methods: {
    renderTch (h, row) {
      let self = this
      return h('div', { class: 'tch-cell' }, [
        renderTchNameWithScore(h, {
          text: tchLabel(row),
          score: row.monthRankScore,
          onClick: () => self.openTchInfo(row.tchId)
        }),
        h('div', { class: 'muted' }, 'ID ' + row.tchId + (row.country ? ' · ' + row.country : ''))
      ])
    },
    rowClassName (row) {
      return row.level === 'expired' ? 'row-danger' : ''
    },
    changeLevel (level) {
      this.level = level
      this.search()
    },
    onAdviserChange () {
      writeStoredAdviserId(this.adviserId)
      this.$root.$emit('hr-badges-refresh')
      this.search()
    },
    search () {
      let self = this
      let params = Object.assign({ level: self.level }, adviserParam(self.adviserId))
      self.searchLoading = true
      self.$http.post(API_PREFIX + '/contract/list', params).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.counts = res.data.counts || {}
          self.rules = res.data.rules || {}
          self.dataList = res.data.rows || []
          self.loadMonthRankScores()
        } else {
          self.dataList = []
        }
      }).finally(function () {
        self.searchLoading = false
      })
    },
    loadMonthRankScores () {
      const rows = this.dataList || []
      if (!rows.length) {
        return
      }
      const ids = rows.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, rows, 'tchId', 'monthRankScore', map)
      })
    },
    openRenew (row) {
      this.currentRow = row
      this.showRenew = true
    },
    openTchInfo (tchId) {
      this.tchInfoId = tchId
      this.showTchInfoModal = true
    },
    confirmSchedule (row) {
      let self = this
      let paused = !!row.schedulePaused
      self.$Modal.confirm({
        title: paused ? '恢复排课' : '暂停排课',
        content: '这只是工作台标记，不改老师在职状态，不挡新约课。',
        onOk: function () {
          self.postSchedule(row, paused ? 'RESUME' : 'PAUSE')
        }
      })
    },
    postSchedule (row, action) {
      let self = this
      self.$http.post(API_PREFIX + '/contract/schedule', {
        tchId: row.tchId,
        action: action,
        note: ''
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success(action === 'PAUSE' ? '已标记暂停排课' : '已恢复排课标记')
          self.$root.$emit('hr-badges-refresh')
          self.search()
        }
      })
    },
    tchExport (row) {
      return tchLabel(row) + ' ID ' + row.tchId + (row.country ? ' · ' + row.country : '')
    },
    periodExport (row) {
      if (!row.crtEndDate) {
        return '未登记合同'
      }
      return (row.crtBeginDate || '—') + ' ~ ' + row.crtEndDate
    },
    daysExport (row) {
      if (row.daysLeft == null || row.level === 'missing') {
        return '—'
      }
      return row.daysLeft
    },
    statusExport (row) {
      let text = codeText(CONTRACT_LEVEL, row.level) || '—'
      if (row.level === 'expired' && row.daysLeft != null) {
        text = '超期 ' + Math.abs(row.daysLeft) + ' 天'
      } else if ((row.level === 'expiring' || row.level === 'normal') && row.daysLeft != null) {
        text = '剩 ' + row.daysLeft + ' 天'
      }
      if (row.renewCount) {
        text += ' 已续签 ' + row.renewCount + ' 次'
      }
      if (row.schedulePaused) {
        text += ' 已暂停排课'
      }
      return text
    },
    exportCsv () {
      if (!this.dataList.length) {
        this.$Message.warning('没有可导出的数据')
        return
      }
      let self = this
      let rows = this.dataList.map(function (row) {
        return [
          self.tchExport(row),
          row.studyAdviserName || '未分配',
          self.periodExport(row),
          self.daysExport(row),
          self.statusExport(row),
          row.lastRenewNote || '—',
          SUGGEST[row.level] || '',
          '档案 登记续签 ' + (row.schedulePaused ? '恢复排课' : '暂停排课')
        ]
      })
      downloadCsv('合同到期提醒.csv', ['外教', '外教运营', '合同期', '剩余/超期(天)', '状态', '最近续签备注', '建议动作', '操作'], rows)
    }
  }
}
</script>
<style scoped lang="less">
.rule-bar {
  margin: 8px 0 12px;
  padding: 8px 12px;
  background: #f8f8f9;
  border-radius: 4px;
  line-height: 22px;
  font-size: 12px;
  color: #495060;
}
.rule-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 50%;
  background: #E89F2D;
}
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.toolbar-label {
  color: #495060;
}
.toolbar-total {
  color: #80848f;
  font-size: 12px;
}
.export-btn {
  margin-left: auto;
}
.list-table /deep/ .muted {
  color: #80848f;
  font-size: 12px;
}
.list-table /deep/ .text-danger {
  color: #E6464E;
}
.list-table /deep/ .tch-cell {
  padding: 4px 0;
}
.list-table /deep/ .ivu-table .row-danger td {
  background: #fff5f5;
}
</style>



// WEBPACK FOOTER //
// HrWorkbenchContract.vue?0583ed07